import React from 'react';

import { Tooltip } from '@mui/material';

import {
  getFullContent,
  HighlightableString,
  makeHighlightableString,
} from '@/app/log-viewer/highlighting/HighlightableString';
import { HighlightableStringView } from '@/app/log-viewer/highlighting/HighlightableStringView';
import { IosRouterTreeSnapshot } from '@/app/log-viewer/timeline/generators/ios/IosRouterTree';
import { IosRouterTreeTooltipContent } from '@/app/log-viewer/timeline/generators/ios/IosRouterTreeTooltipContent';
import { LogEntry } from '@/parsing/LogEntry';

import { LogEntryCellModel, LogEntryCellModelData, LogEntryCellType } from '../LogEntryCellModel';

export interface LogEntryGenericCellModelData extends LogEntryCellModelData {
  content: HighlightableString;
  iosRouterTreeSnapshot?: IosRouterTreeSnapshot;
}

export interface LogEntryGenericCellModel extends LogEntryCellModel {
  data: LogEntryGenericCellModelData;
}

export abstract class LogEntryGenericCellModelFactory {
  static make(
    logEntry: LogEntry,
    iosRouterTreeSnapshot?: IosRouterTreeSnapshot,
  ): LogEntryGenericCellModel {
    return {
      applySettings: () => {},
      data: {
        type: LogEntryCellType.Generic,
        content: makeHighlightableString(logEntry.content),
        iosRouterTreeSnapshot,
      },
    };
  }
}

export class LogEntryGenericCell extends React.Component<{ model: LogEntryGenericCellModel }> {
  render() {
    const content = (
      <div className="verbatim-multiline">
        <HighlightableStringView string={this.props.model.data.content} />
      </div>
    );

    if (this.props.model.data.iosRouterTreeSnapshot) {
      return (
        <Tooltip
          classes={{
            tooltip: 'router-tree-log-line-tooltip',
          }}
          title={
            <IosRouterTreeTooltipContent
              eventText={getFullContent(this.props.model.data.content)}
              snapshot={this.props.model.data.iosRouterTreeSnapshot}
            />
          }
        >
          {content}
        </Tooltip>
      );
    }

    return content;
  }
}
